import i18n from "i18next";
import * as yup from "yup";

import { CustomerCardFormType } from "@/components/features/ToDos/CustomerCardPage/formType";
import { Shape } from "@/core/yup";

import { ContractType, CustomerCardAuthorizationFormType } from "./formType";

export const formSchemaAuthorization = yup.object<{}, Shape<CustomerCardFormType>>({
    authorization: yup.object<{}, Shape<CustomerCardAuthorizationFormType>>({
        // @ts-ignore
        contractType: yup.mixed<ContractType>().requiredIf("giveAuthorizationPermission"),
        selectedMandate: yup.number().requiredIf("giveAuthorizationPermission"),
        selectedContracts: yup.array().when(["contractType"], {
            is: ContractType.SELECTED,
            then: (schema) => schema.min(1, i18n.t("Validations.Required")),
        }),
    }),
});
